import React from 'react';
import { cssMap } from '@compiled/react';
import { defineMessages, useIntl } from 'react-intl';

import { Box } from '@atlaskit/primitives/compiled/box';
import Spinner from '@atlaskit/spinner/spinner';
import { token } from '@atlaskit/tokens';

import { FORGE_MODULE_ATTACHMENT_ACTION } from '../../ForgeModuleType.ts';
import { calculateSize } from '../../utils/sizes.ts';

const i18n = defineMessages({
	loadingDetails: {
		id: 'forge-ui.attachment-action.metadata.loading-details',
		defaultMessage: 'Loading attachment details',
		description: 'Accessible label for the spinner shown while Forge attachment details load.',
	},
});

const styles = cssMap({
	loading: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		boxSizing: 'border-box',
		maxWidth: '100%',
		paddingBlock: token('space.150'),
		paddingInline: token('space.200'),
	},
});

// Use the same viewport while loading the chunk and the Forge resource, so the
// spinner stays centered and the popup does not initially collapse around it.
export const AttachmentActionMetadataLoading = ({
	viewportSize,
}: {
	viewportSize?: unknown;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { height, width } = calculateSize(FORGE_MODULE_ATTACHMENT_ACTION, viewportSize, 'metadata');

	return (
		<Box role="status" style={{ height, width }} xcss={styles.loading}>
			<Spinner label={formatMessage(i18n.loadingDetails)} size="small" />
		</Box>
	);
};
